// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a44592b7","284":"954d06e2","498":"8d4f6a66","647":"807c6822","703":"d4bfc6ac"}[chunkId] + ".chunk.js";
};